/** Small ES/EN pill toggle, reused by every bilingual game screen. */
export function LangToggle({ lang, onChange }) {
  return (
    <div className="inline-flex shrink-0 items-center rounded-full border border-slate-700 bg-slate-900/80 p-0.5 text-[10px] font-black" role="group" aria-label="ES EN">
      {['es', 'en'].map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => onChange(l)}
          className={`px-2 py-0.5 rounded-full uppercase cursor-pointer transition-colors ${
            lang === l ? 'bg-amber-400 text-slate-950' : 'text-slate-400 hover:text-white'
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  )
}
